export const errorMessageConstants = {
  InvalidUsernameOrPassword: "Login or password is incorrect",
  InvalidTokenPassed: "Session expired. Please login to the portal",
  NoTokenPassed: "Session expired. Please login to the portal",
  FailedLoginAndLoginTimeoutEngaged:
    "Many login attempts. Please try again later.",
  TooManyAttempts: "Too many attempts. Please try again later.",
  //Unauthorized: 'Session expired. Please login to the portal',
  TokenCacheNotAvailable:
    "Service is currently unavailable. Please try again later.",

  CustomerValidation_ConflictWithExistingItem_SncId:
    "Value entered in field 'ServiceNow ID' conflicts with already existing company 'ServiceNow Id'",
  CustomerValidation_ConflictWithExistingItem_Project:
    "Entered 'Project' exists in configuration of another customer",
  CustomerValidation_ConflictWithExistingItem_LegacySystemUsername:
    'Entered "platform" + "username" combination exists in configuration of another customer. Try searching by username to find that company.',

  ParameterMissingStartEnd:
    "You have to specify the Start and End parameters to start search.",

  CustomerValidation_ConflictWithExistingItem_SenderId:
    "A customer may not have senders with the same sender id",
  CustomerValidation_ConflictWithExistingItem_CustomerCode:
    "Sender's customer code conflicts with another existing sender's customer code or customer's Global ID",
  CustomerValidation_ConflictWithExistingItem_GlobalId:
    "Customer's Global ID conflicts with another customer's Global ID or Sender's customer code",

  ReportPipelineNotFound: "Report pipeline is not found.",

  LdlsServiceGenericError:
    "Unknown error. Please retry or report to the TnT team.",
  LdlsArgumentObjectIsNotPassed:
    "Parameter is missing, please report to the TnT team",
  LdlsUploadedFileNameIsIncorrect:
    "Unexpected filename. Allowed filenames are: 01. Tammikuu.xlsx,  02. Helmikuu.xlsx,  03. Maaliskuu.xlsx,  04. Huhtikuu.xlsx,  05. Toukokuu.xlsx,  06. Kesäkuu.xlsx,  07. Heinäkuu.xlsx,  08. Elokuu.xlsx,  09. Syyskuu.xlsx,  10. Lokakuu.xlsx,  11. Marraskuu.xlsx,  12. Joulukuu.xlsx",
  LdlsYearIsIncorrect:
    "Unexpected year. Please select current or previous year.",
  LdlsYearFolderDoesNotExist:
    "The service has technical problems, please report to the TnT team.",
  LdlsUploadedFileContentIsInvalid: "File content is empty or invalid.",
};
